app.factory('clinicService', ['$q', 'baseService', 'objectHelper', 'config',
    function($q, baseService, objectHelper, config) {

        function AllergyService() {

            this.getById = function(clinicId) {
                return baseService.get(config.API_URL + '/clinics/' + clinicId).then(
                    function(successResponse) {
                        var data = objectHelper.translateObject(successResponse, ClinicVO);
                        data = objectHelper.convertTimesToDates(data);

                        return data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

        }

        return new AllergyService();
    }
]);
